module.exports = __webpack_public_path__ + "static/media/0.55d5cf9e.jpg";